<template>
  <PanelRow>
    <Panel class="newcontest" id="makepdf">

      <p class="main-title1">{{ 'aquest:contests.invoice' | trans }}</p>
      <button class="print-btn" id="printWin" @click="printWindow()">Print</button>


      <header class="clearfix">
        <div id="logo">
          <img src="/static/img/apps_logo.197a163.svg">
        </div>
        <div id="company" class="clearfix" v-if="!companyData.length">
          <div><b>To</b></div>
          <div>Enkronos d.o.o</div>
          <div>Polje 12</div>
          <div>5680 Sempeter</div>
          <div>Slovenia</div>
          <div>Vat : 567547567</div>
        </div>
        <div id="company" class="clearfix" v-else-if="companyData.length">
          <div><b>To</b></div>
          <div>{{companyData[0]['company_name']}}</div>
          <div>{{companyData[0]['company_registered_address']}}</div>
          <div>{{companyData[0]['company_registered_city']}}, {{companyData[0]['company_registered_countries_name']}}</div>
          <!-- <div>{{companyData[0]['company_registered_countries_name']}}</div> -->
          <div>Vat : {{companyData[0]['company_vat']}}</div>
        </div>
        <div id="project">
            <div><b>From</b></div>
          <div>Enkronos OÜ</div>
          <div>Keemia tn 4</div>
          <div>10616 Tallinn, Estonia</div>
          <!-- <div>Estonia</div> -->
          <!-- <div><img class="mail-icon" src="../../../assets/img/call.png" /> ++386 5 5555 550</div>
          <div><img class="mail-icon" src="../../../assets/img/email.png" /> info@enkronos.com</div> -->
          <div>Vat : EE102151239</div>
        </div>
      </header>

      <!-- <p class="main-title1">{{ 'aquest:contests.invoice' | trans }} N<sup>O</sup> EA{{invoiceNumber}}{{ todayDate | formatyear }}</p> -->
      <p class="main-title1">{{ 'aquest:contests.invoice' | trans }} N<sup>O</sup> EA{{invoiceNumber}}</p>
      <div class="more-info-print">
          <div class="more-info-date">Date :</div>
          <div class="more-info-time">{{invoiceDate | formatDateTimer }}</div>
      </div>
      <div class="more-info-print">
          <div class="more-info-date">Payment Method :</div>
          <div class="more-info-time">{{paymentMethod}}</div>
      </div>
      <main>
        <table class="table-new">
          <thead>
            <tr>
              <th class="service">Qty</th>
              <th class="desc">Product</th>
              <th class="fix-width"> Unit Price</th>
              <th class="fix-width">Extended Price</th>
              <th class="fix-width">Vat</th>
              <th class="fix-width">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="service">1</td>
              <td class="desc">
                  <span>{{questName}}</span>
                  <small>For Service through : {{questSDate | formatDate }} - {{questEDate | formatDate }}</small>
              </td>
              <td class="unit">{{unitPrice}}</td>
              <td class="qty">{{extPrice}}</td>
              <td class="total">{{vatPrice}}</td>
              <td class="total">{{subTotal}}</td>
            </tr>
            
            <tr class="price-quotes mt-5">
              <td colspan="5">SUBTOTAL</td>
              <td class="total">{{subTotal}}</td>
            </tr>
            <tr class="price-quotes">
              <td colspan="5">VAT</td>
              <td class="total">{{vatPrice}}</td>
            </tr>
            <tr class="price-quotes">
              <td colspan="5" class="grand">Total</td>
              <td class="grand total">{{total}}</td>
            </tr>
          </tbody>
        </table>
      </main>

    </Panel>
  </PanelRow>
</template>

<script>
import axios from "axios";
import Vue from 'vue';
import VueAlertify from 'vue-alertify';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import moment from 'moment'


Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY');
  }
});
Vue.filter('formatDateTimer', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm:ss');
  }
});
Vue.filter('formatyear', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY');
  }
});

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);
Vue.use(VueAlertify, {
  notifier: {
    delay: 3,
    position: 'top-right',
    closeButton: false,
  },
});



export default {
  name: "Transaction",
  mixins: [],
  data () {
      return {
        myQuestData: [],
        invoiceDate: "",
        invoiceNumber: "",
        invoiceDate: "",
        paymentMethod: "",
        questName: "",
        questSDate: "",
        questEDate: "",
        unitPrice: "",
        extPrice: "",
        vatPrice: "",
        subTotal: "",
        total: "",
        todayDate: "",
        companyData: {},
      }
    },
    computed: {},
    asyncComputed: {},
    methods: {
      printWindow: function () {
        document.getElementById('printWin').style.visibility = 'hidden';
        window.print();
        document.getElementById('printWin').style.visibility = 'visible';
      },
      createPDF: function () {
            window.print();
            // var doc = document.getElementById('makepdf');

            // //Wait until PDF is ready to print    
            // if (typeof doc.print === 'undefined') {    
            //     setTimeout(function(){printDocument('makepdf');}, 1000);
            // } else {
            //     doc.print();
            // }
        }
    },
    created () {
      var InvoiceDetailID = window.localStorage.getItem('InvoiceDetailID');
    //   this.$router.up({name: 'admin.invoicesdetail', params:{id:InvoiceDetailID}});

      this.api.post('/sso/aquest/master/getinvoice',{ "billing_id": this.$route.params.id }, {
        "app-token": "6e837457fd14dd0a05d8",
      })
      .then((response) => {
        if(response.status == 200) {
          var billings_cycles = '';
          response = response.data;

          var d = new Date();
          this.todayDate = d.getFullYear();
          var countries_id = response[0].countries_id;
          this.vatPrice = response[0].cost_tax+' '+response[0].currency;
          this.total = response[0].cost_final+' '+response[0].currency;
          if(countries_id == 72) {
            var sub =  response[0].cost_final;
            var am = ((sub*20)%100);
            this.vatPrice = am+' '+response[0].currency;
            var sm = sub+am;
            this.total = sm+' '+response[0].currency;
          }
          this.invoiceNumber = response[0].id;
          this.invoiceDate = response[0].invoice_date;
          this.unitPrice = response[0].cost_clean+' '+response[0].currency;
          this.extPrice = '0'+' '+response[0].currency;
          this.subTotal = response[0].cost_final+' '+response[0].currency;
          

          var billings_transactions = response['billings_transactions'];
          if(billings_transactions != "") {
            this.paymentMethod = billings_transactions[0].gateway;
          }
          else {
            this.paymentMethod = "Not Paid"
          }

          var billings_contracts = response['billings_contracts'];
          if(billings_contracts != "") {
            billings_cycles = billings_contracts[0].billings_cycles;
          }
          if(billings_cycles != '') {
            if(billings_cycles == 'monthly') {
              var questEDate = new Date(this.invoiceDate);
              questEDate.setDate(questEDate.getDate() + 30);
              this.questSDate = this.invoiceDate;
              this.questEDate = questEDate;
            }
            else if(billings_cycles == 'annually' || billings_cycles == 'yearly') {
              var questEDate = new Date(this.invoiceDate);
              questEDate.setDate(questEDate.getDate() + 365);
              this.questSDate = this.invoiceDate;
              this.questEDate = questEDate;
            }
          }
          else {
            var questEDate = new Date(this.invoiceDate);
            questEDate.setDate(questEDate.getDate() + 30);
            this.questSDate = this.invoiceDate;
            this.questEDate = questEDate;
          }
          

          var billings_plans_id = response['billings_plans_id'];
          if(billings_plans_id != "") {
            this.questName = billings_plans_id[0].name;
          }
        }
      })
      .catch((error) => {
          this.$alertify.error(error);
      })


      this.api.post('/sso/aquest/master/getcompany',{ "apptokens_id": InvoiceDetailID }, {
        "app-token": "6e837457fd14dd0a05d8",
      })
      .then((response) => {
        if(response.status == 200) {
          response = response.data;
          this.companyData = response;
        }
      })
      .catch((error) => {
          this.$alertify.error(error);
      })

    },

};
</script>


<style>
@import "../../apps/aquest/css/style.css";
</style>


<style lang="scss" scoped>
@import "../../apps/aquest/scss/variables";

.statusfilters {
  @media (min-width: $lg-min) {
    flex-wrap: nowrap;
  }
  justify-content: center;
}
.statusfilter {
  flex-basis: 33.33%;
  flex-grow: 0;
  flex-shrink: 1;
  cursor: pointer;
  color: $color-primary;
  &.active,
  &:hover {
    color: $default-color;
  }
  &.active {
    background: mix(white, $color-primary, 85%);
  }
}

.contests-list {
  text-align: center;
  .btn {
    margin: 30px 0;
    @media (max-width: $sm-max) {
      margin: 20px 0;
    }
  }
  .panel {
    padding: 14px;
    a.contest {
      @media (min-width: $xs-min) {
        display: flex;
      }
      > * {
        flex-basis: 50%;
        flex-grow: 0;
        flex-shrink: 0;
        overflow: hidden;
        position: relative;
        @media (min-width: $xs-min) {
          width: 50%;
        }
      }
      > figure {
        img {
          width: 100%;
        }
        >>> .placeholder {
          padding: 16%;
        }
        figcaption {
          position: absolute;
          display: inline-block;
          width: 73px;
          height: 73px;
          line-height: 30px;
          font-size: 40px;
          background: white;
          bottom: -10px;
          right: -10px;
          color: $primary-color;
          padding: 10px;
        }
      }
      > section {
        text-align: left;
        @media (min-width: $xs-min) {
          display: flex;
          flex-direction: column;
        }
        > * {
          width: 100%;
          @include font-size(18px);
        }
        > h3 {
          @include font-size(20px);
          margin: 0 0 9px;
        }
        > p {
          overflow: hidden;
          flex-grow: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .cell-status >>> {
          dt,
          dd {
            display: inline;
            line-height: 2;
          }
          dd {
            color: $color-primary;
            font-weight: 700;
            &::before {
              content: " ";
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/general/Transaction.vue